import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NoxDialogParam,
  NoxDialogSize,
  NoxDialogType,
} from '../../models/nox-dialog-param';
import { CommonModule } from '@angular/common';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { ClickableDirective } from '../../directives/clickable.directive';

@Component({
    selector: 'app-nox-dialog',
    imports: [CommonModule, ClickableDirective],
    templateUrl: './nox-dialog.component.html',
    styleUrl: './nox-dialog.component.scss'
})
export class NoxDialogComponent {
  cancel() {}
  data: NoxDialogParam;
  dialogSize = NoxDialogSize;
  noxAlertType = NoxDialogType;
  faClose = faClose;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) data: NoxDialogParam,
    public dialogRef: MatDialogRef<NoxDialogComponent>,
  ) {
    this.data = data;
  }
  closeDialog() {
    this.dialogRef.close();
  }
  positiveListener() {
    /**
     * Listener added in component
     */
  }
  negativeListener() {
    /**
     * Listener added in component
     */
  }
}
